module.exports = __webpack_public_path__ + "img/s2-hx-4.5d86f654.png";